import userRoles, {
  aprobador,
  consultaServicios,
  inspector,
  notificador,
  proveedorAdministrador,
  proveedorNotificador,
  referenteCompras,
  referenteControlGestion,
  responsableProyecto,
  solicitante
} from '../../security/constantsRols';
import { getUrlWithSessionCreds } from '../../utils/globalFunctions';
import { apiCertificationsApp } from '../../resources/environmentConstants';

/* eslint-disable consistent-return */
export const rolText = (rol) => {
  if (rol === 'ProveedorAdministrador') {
    return 'Proveedor Administrador';
  }
  if (rol === 'ProveedorNotificador') {
    return 'Proveedor Notificador';
  }
  if (rol === 'Notificador') {
    return 'Notificador';
  }
  if (rol === 'ConsultaServicios') {
    return 'Consulta Servicios';
  }
  if (rol === 'Aprobador') {
    return 'Aprobador';
  }
  if (rol === 'Solicitante') {
    return 'Solicitante';
  }
};

export const rolDuo = (rol) => {
  if (rol.includes('ProveedorAdministrador', 'ProveedorNotificador')) {
    return 'Prov. Administrador / Notificador';
  }
  if (rol.includes('SupervisorNotificador', 'Aprobador')) {
    return 'Notificador / Aprobador';
  }
  if (rol.includes('Solicitante', 'Aprobador')) {
    return 'Solicitante / Aprobador';
  }
};

export const rolUserMapper = (roles = []) => {
  const rolesUser = roles.map((rol) => {
    // Solicitante
    if (rol.includes(solicitante)) {
      return solicitante;
    }
    // Prov. Admin.
    if (rol.includes(proveedorAdministrador)) {
      return proveedorAdministrador;
    }
    // Prov. Notif
    if (rol.includes(proveedorNotificador)) {
      return proveedorNotificador;
    }
    // Aprobador
    if (rol.includes(aprobador)) {
      return aprobador;
    }
    // Notificador
    if (rol.includes(notificador)) {
      return notificador;
    }
    // consultaServicios
    if (rol.includes(consultaServicios)) {
      return consultaServicios;
    }
    // Responsable PEP Proyecto
    if (rol.includes(responsableProyecto)) {
      return responsableProyecto;
    }
    // Referente Control de Gestion
    if (rol.includes(referenteControlGestion)) {
      return referenteControlGestion;
    }
    // Referente Compras
    if (rol.includes(referenteCompras)) {
      return referenteCompras;
    }
    // Inspector
    if (rol.includes(inspector)) {
      return inspector;
    }

    return '';
  });

  return rolesUser.join('/');
};

const yClickLinks = () => [
  {
    id: 1,
    title: 'Solicitudes de Servicio',
    links: [
      {
        id: 12,
        url: '/createMultiple',
        callback: () => {},
        name: 'Crear nueva Solicitud',
        permissions: [userRoles.SOLICITANTE]
      },
      {
        id: 11,
        url: '/',
        callback: () => {},
        name: 'Consultar Bandeja de Solicitud de Servicio',
        permissions: [
          userRoles.INSPECTOR,
          userRoles.PROVEEDOR_ADMINISTRADOR,
          userRoles.PROVEEDOR_NOTIFICADOR,
          userRoles.USUARIO_CONSULTAS,
          userRoles.SOLICITANTE,
          userRoles.SUPERVISOR_NOTIFICADOR_YPF,
          userRoles.RESPONSABLE_PEP_PROYECTO,
          userRoles.GERENTE_COMPRA
        ]
      },
      {
        id: 15,
        url: '/manage-temp/workReport',
        callback: () => {},
        name: 'Administrar modelos de Solicitudes',
        permissions: [userRoles.PROVEEDOR_NOTIFICADOR, userRoles.SUPERVISOR_NOTIFICADOR_YPF]
      },
      {
        id: 16,
        url: '/manage-temp/request',
        callback: () => {},
        name: 'Administrar modelos de Solicitudes',
        permissions: [userRoles.SOLICITANTE]
      },
      {
        id: 13,
        url: '/create-asds',
        callback: () => {},
        name: 'Notificar Parte de Trabajo s/ Solicitud',
        permissions: [userRoles.PROVEEDOR_NOTIFICADOR, userRoles.SUPERVISOR_NOTIFICADOR_YPF]
      },
      {
        id: 14,
        url: '/approver',
        callback: () => {},
        name: 'Supervisar Partes de Trabajo',
        permissions: [userRoles.APROBADOR]
      }
    ]
  },
  {
    id: 2,
    title: 'Inspección y certificación',
    links: [
      {
        id: 21,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/inspeccion/resumen`),
        callback: () => {},
        name: 'Gestionar Autorizaciones',
        permissions: [userRoles.INSPECTOR]
      },
      {
        id: 22,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/errores/partes`),
        callback: () => {},
        name: 'Consultar Bandeja de Errores de Certificación',
        permissions: [
          userRoles.CONTROL_ERRORES_SAP,
          userRoles.RESPONSABLE_PEP_PROYECTO,
          userRoles.GERENTE_COMPRA
        ]
      },
      {
        id: 23,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/habilitas`),
        callback: () => {},
        name: 'Consultar Bandeja de Habilitas',
        permissions: [userRoles.INSPECTOR, userRoles.PROVEEDOR_ADMINISTRADOR]
      }
    ]
  },
  {
    id: 3,
    title: 'Reportes',
    links: [
      {
        id: 31,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/reporte-certificacion`),
        callback: () => {},
        name: 'Generar Reporte de Trazabilidad',
        permissions: [
          userRoles.ADMINISTRADOR_CONTRATO,
          userRoles.INSPECTOR,
          userRoles.REFERENTE_CONTROL_GESTION,
          userRoles.CONTROL_ERRORES_SAP,
          userRoles.PROVEEDOR_ADMINISTRADOR,
          userRoles.PROVEEDOR_NOTIFICADOR,
          userRoles.USUARIO_CONSULTAS,
          userRoles.SOLICITANTE,
          userRoles.SUPERVISOR_NOTIFICADOR_YPF,
          userRoles.APROBADOR,
          userRoles.REFERENTE_COMPRAS,
          userRoles.RESPONSABLE_PEP_PROYECTO,
          userRoles.GERENTE_COMPRA
        ]
      },
      {
        /* El id:32 esta tomado por el reporte de trazabilidad */
        id: 33,
        url: '/reporte-provision',
        callback: () => {},
        name: 'Generar Reporte de Provisión',
        permissions: [userRoles.INSPECTOR, userRoles.REFERENTE_CONTROL_GESTION]
      }
    ]
  },
  {
    id: 4,
    title: 'Administración',
    links: [
      {
        id: 41,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/contratos`),
        callback: () => {},
        name: 'Configurar Contratos',
        permissions: [userRoles.ADMINISTRADOR_CONTRATO, userRoles.INSPECTOR]
      },
      {
        id: 42,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/cuenta-contable`),
        callback: () => {},
        name: 'Configurar Cuenta Contable',
        permissions: [userRoles.REFERENTE_CONTROL_GESTION]
      }
    ]
  }
];

// devuelve un array filtrado de links respecto a un array de roles/permisos
const verifyLinkPermissions = (linksArray, roles) =>
  linksArray.filter((l) => roles.some((r) => l.permissions.includes(r.nombre)));

// retorna el array de yClickLinks filtrado por los roles/permisos
export const getAllowedLinks = (rolesArray) => {
  // si no existen roles
  if (!Array.isArray(rolesArray) || (Array.isArray(rolesArray) && !rolesArray.length)) return [];

  // rolesArray = [{ id: 1, nombre: 'Admin'}, {id: 2, nombre: 'Insp'}, ...]
  // se mapean el/los role/s del usuario

  const returnedLinks = [];

  yClickLinks().forEach((yClickLink) => {
    // se obtienen los links de cada sección, filtrados por roles/permisos
    const links = verifyLinkPermissions(yClickLink.links, rolesArray);

    // se verifica que haya al menos 1 item dentro del array
    // para pushearlo al array que devuelve la función
    if (links.length > 0) {
      returnedLinks.push({
        id: yClickLink.id,
        title: yClickLink.title,
        links
      });
    }
  });

  return returnedLinks;
};
